import axios from "axios";
import { backendUrl } from "./constants";

const axionIns = axios.create({
  baseURL: backendUrl + "api/",
});

// ✅ Automatically attach token if present
axionIns.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["token"] = token;
  }

  // ✅ Let Axios set the Content-Type automatically
  // Only manually set for JSON if needed
  if (!(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

export default axionIns;
